var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFillCart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #33a0ff;\n        stroke: #33a0ff;\n        stroke-width: 2px;\n        opacity: 0.7;\n      }\n\n      .cls-2 {\n        fill: #fff;\n        fill-rule: evenodd;\n      }\n\n      .cls-3 {\n        stroke: none;\n      }\n\n      .cls-4 {\n        fill: none;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fill_cart",
    transform: "translate(-507 -1374)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    className: "cls-1",
    transform: "translate(507 1374)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 23,
    cy: 23,
    r: 23
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 23,
    cy: 23,
    r: 22
  })), /*#__PURE__*/React.createElement("path", {
    id: "cart_2",
    className: "cls-2",
    d: "M428.932,523a1.993,1.993,0,0,0,1.952-1.608l1-5A2,2,0,0,0,429.927,514h-9.956v-1a1,1,0,0,0-1-1H416.98a1,1,0,0,0,0,2h1v10a2,2,0,1,0,1.991,2h6.969a1.992,1.992,0,1,0,1.992-2h-8.961v-1Zm1-7-1,5h-8.961v-5h9.956Z",
    transform: "translate(106.029 877)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFillCart);
export default __webpack_public_path__ + "static/media/fill_cart.d46e5284f57c9e31583992e5dd167eaa.svg";
export { ForwardRef as ReactComponent };